/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Invite_X15_JoiningInputs */

const en_invite_x15_joining = /** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adding you to ${i?.workspace}.`)
};

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const ar_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const he_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const ur_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const es_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const fr_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const de_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const pt_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const hi_invite_x15_joining = en_invite_x15_joining;

/** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */
const bn_invite_x15_joining = en_invite_x15_joining;

/**
* | output |
* | --- |
* | "Adding you to {workspace}." |
*
* @param {Invite_X15_JoiningInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_joining = /** @type {((inputs: Invite_X15_JoiningInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_JoiningInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_joining(inputs)
	if (locale === "he") return he_invite_x15_joining(inputs)
	if (locale === "ur") return ur_invite_x15_joining(inputs)
	if (locale === "es") return es_invite_x15_joining(inputs)
	if (locale === "fr") return fr_invite_x15_joining(inputs)
	if (locale === "de") return de_invite_x15_joining(inputs)
	if (locale === "pt") return pt_invite_x15_joining(inputs)
	if (locale === "hi") return hi_invite_x15_joining(inputs)
	if (locale === "bn") return bn_invite_x15_joining(inputs)
	return en_invite_x15_joining(inputs)
});